import { Injectable } from '@angular/core';
import { Subject, interval } from 'rxjs';
import { NGXLogger } from "ngx-logger";

@Injectable({
  providedIn: 'root',
})
export class GlobalClickTrackingService {
  private clicks: any[] = [];
  private interval = 60000;
  private storageKey = 'pendingClickEvents';
  private stopTracking = new Subject<void>();

  constructor(private logger: NGXLogger) {

  }

  startTracking() {
    this.loadAndPostEvents();
    document.addEventListener('click', this.trackClick.bind(this), true);

    interval(this.interval).subscribe(() => {
      this.postClickEvents();
    });

    window.addEventListener('beforeunload', () => this.saveClickEvents());
  }

  trackClick(event: MouseEvent) {
    const targetElement = event.target as HTMLElement;
    this.clicks.push({
      tagName: targetElement?.tagName ?? 'N/A',
      id: targetElement?.id ?? 'N/A',
      text: targetElement?.innerText?.substring(0, 100) ?? 'N/A',
      innerHtml: targetElement?.innerHTML?.substring(0, 100) ?? 'N/A',
      classes: targetElement?.className ?? 'N/A',
      timestamp: new Date().toISOString(),
    });
  }

  saveClickEvents() {
    if (this.clicks.length > 0) {
      sessionStorage.setItem(this.storageKey, JSON.stringify(this.clicks));
    }
  }

  postClickEvents() {

    this.loadAndPostEvents();
    try {
      if (this.clicks.length > 0) {
        this.logger.info('Posting click events:', this.clicks);
        this.clicks = [];
      }
    } catch (error) {
      this.logger.error('Posting click events:', this.clicks);
    }
  }

  loadAndPostEvents() {
    const storedClicks = sessionStorage.getItem(this.storageKey);
    if (storedClicks) {
      const clicksToPost = JSON.parse(storedClicks);
      if (clicksToPost.length > 0) {
        this.logger.error('Posting stored click events:', clicksToPost);
        sessionStorage.removeItem(this.storageKey);
      }
    }
  }

  stopTrackingClicks() {
    document.removeEventListener('click', this.trackClick.bind(this), true);
    this.stopTracking.next();
  }
}
